var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"rules":[_vm.validateRequired],"items":_vm.options,"label":_vm.title,"required":_vm.required,"disabled":_vm.disabled},model:{value:(_vm.dropdown),callback:function ($$v) {_vm.dropdown=$$v},expression:"dropdown"}})
}
var staticRenderFns = []

export { render, staticRenderFns }